// NPM
import { useEffect } from "react";

// Services
import campaignService from "services/campaignService";

function Theme() {
  const loadTheme = async () => {
    const cssUrl = `https://thesignal.voxpoplabs.com/campaigns/${campaignService.getCampaignName()}/theme/styles/styles.css`;

    if (document.querySelectorAll(`link[href="${cssUrl}"]`).length === 0) {
      var styleLink = document.createElement("link");
      styleLink.rel = "stylesheet";
      styleLink.href = cssUrl;

      document.head.appendChild(styleLink);
    }
  };

  // Hooks
  useEffect(() => loadTheme(), []);

  return null;
}

export default Theme;
